<template>
  <!-- Просмотр фото поверх страницы: листание по фото сообщения, «Сохранить», закрытие крестиком, Esc и кликом мимо -->
  <v-dialog
    :value="!!photo"
    max-width="none"
    overlay-color="#000"
    overlay-opacity="0.85"
    content-class="support-photo-viewer"
    @input="$event || $emit('close')"
  >
    <div v-if="photo" class="photo-viewer" @click.self="$emit('close')">
      <div class="photo-viewer__bar">
        <span v-if="many" class="photo-viewer__counter">{{ index + 1 }} / {{ photos.length }}</span>
        <v-btn
          icon
          dark
          title="Сохранить изображение"
          @click="$emit('save', photo)"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          title="Закрыть"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-btn
        v-if="many"
        class="photo-viewer__nav photo-viewer__nav--prev"
        icon
        dark
        x-large
        title="Предыдущее"
        @click="step(-1)"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <img
        :key="photo.id"
        class="photo-viewer__img"
        :src="sources[photo.id] || photo.url"
        alt="Фото"
        @error="refresh(photo)"
      >

      <v-btn
        v-if="many"
        class="photo-viewer__nav photo-viewer__nav--next"
        icon
        dark
        x-large
        title="Следующее"
        @click="step(1)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
  import supportApi from '@/api/support'

  export default {
    name: 'PhotoViewer',
    props: {
      // Фото сообщения целиком: листаем в его пределах. Пустой массив - окно закрыто.
      photos: { type: Array, default: () => [] },
      start: { type: Number, default: 0 },
    },
    data () {
      // sources - свежие ссылки взамен протухших: подпись живёт 10 минут, лента могла висеть дольше.
      return { index: 0, sources: {}, refreshed: {} }
    },
    computed: {
      photo () {
        return this.photos[this.index] || null
      },
      many () {
        return this.photos.length > 1
      },
    },
    watch: {
      photos: {
        immediate: true,
        handler (next, prev) {
          // С фото стартуем только при открытии: лента обновляется и пересоздаёт массив, листание не сбрасываем.
          if (!prev || !prev.length) this.index = this.start
          this.index = Math.min(this.index, Math.max(next.length - 1, 0))
          if (next.length) window.addEventListener('keydown', this.onKey)
          else window.removeEventListener('keydown', this.onKey)
        },
      },
    },
    beforeDestroy () {
      window.removeEventListener('keydown', this.onKey)
    },
    methods: {
      step (delta) {
        // По кругу: с последнего вперёд - на первое.
        this.index = (this.index + delta + this.photos.length) % this.photos.length
      },
      onKey (e) {
        if (!this.many) return
        if (e.key === 'ArrowLeft') this.step(-1)
        else if (e.key === 'ArrowRight') this.step(1)
      },
      // Одна попытка на фото: если и свежая не грузится, второй круг запросов не нужен.
      async refresh (photo) {
        if (this.refreshed[photo.id]) return
        this.$set(this.refreshed, photo.id, true)
        try {
          this.$set(this.sources, photo.id, await supportApi.downloadUrl(photo.id))
        } catch (e) {
          // Битое фото остаётся битым: ошибку покажет сам браузер, окно при этом работает.
        }
      },
    },
  }
</script>

<style lang="less">
// Контент диалога на весь экран без рамки и тени: фото живёт прямо на затемнении.
.v-dialog.support-photo-viewer {
  width: 100%;
  height: 100%;
  max-height: none;
  margin: 0;
  overflow: hidden;
  border-radius: 0;
  box-shadow: none;
}
</style>

<style scoped lang="less">
@import '../tokens.less';

.photo-viewer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 72px 96px;
}

.photo-viewer__bar {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 4px;
  align-items: center;
}

.photo-viewer__counter {
  margin-right: 12px;
  font-size: 14px;
  color: @fakt-white;
}

.photo-viewer__img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  object-fit: contain;
}

.photo-viewer__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &--prev {
    left: 16px;
  }

  &--next {
    right: 16px;
  }
}
</style>
